import Updater from './Updater'

window.wsDebug = false;

export default class Socket {
    constructor() {
        this.listeners = [];
        this.oncers = [];
        this.connectRetries = 10;
        this.timerStopped = false;

        this.connect();
        this.once('init', this.initSuccess);

        var self = this;
        if (this.connection) {
            this.connection.onopen = function() {
                // self.onopen();
            };
            this.connection.onmessage = function(event) {
                self.onmessage(event);
            };
            this.connection.onclose = function(event) {
                self.onclose(event);
            }
        }
        this.startTimer();

        return this;
    }

    connect() {
        try {
            this.connection = new WebSocket(this.getLink());
        } catch (e) {
            this.onclose();
        }
        this.timerStopped = false;
    }

    reconnect() {
        this.stopTimer();
        if (this.connectRetries) {
            this.connectRetries--;
            this.connect();
        }
    }

    getLink() {
        return window.config.protocol + (window.location.protocol == 'http:' ? '' : 's') + '://' + window.config.host + ':' + window.config.port;
    }

    getId() {
        return this.id;
    }

    setId(id) {
        this.id = id;
    }

    onopen() {
        this.send({
            action: 'init',
            id: this.getId()
        });
    }

    onmessage(event) {
        var json = JSON.parse(event.data);

        if (window.wsDebug)
            console.log(json);

        if (typeof this.listeners[json.channel] !== 'undefined')
            return this.listeners[json.channel](json.data);

        if (typeof this.oncers[json.channel] !== 'undefined') {
            var cb = this.oncers[json.channel];
            delete this.oncers[json.channel];
            return cb(json.data);
        }
    }

    onclose(event) {
        this.stopTimer();

        if (event && event.wasClean)
            return;

        if (window.wsDebug)
            console.log(event);

        if (! event || event.code == 1006) {
            // $('#socket-error').show();
            Updater.init();

            // setTimeout(() => $('#socket-error').fadeOut('slow'), 10000);
        }
    }

    send(data) {
        setTimeout(function(socket, data) {
            if (socket.connection && socket.connection.readyState == 1) {
                socket.connection.send(JSON.stringify(data))
                return socket;
            }
            return socket.send(data);
        }, 5, this, data);
    }

    initSuccess(data) {
        window.socket.setId(data.id);
    }

    listen(channel, callback) {
        this.listeners[channel] = callback;

        return this;
    }

    once(channel, callback) {
        this.oncers[channel] = callback;

        return this;
    }

    startTimer() {
        if (this.timerStopped || ! this.connection)
            return this.timerStopped = false;

        setTimeout(() => {
            if (this.connection) {
                var data = {
                    channel: 'multichannel',
                    data: {
                        channels: Object.keys(this.listeners)
                    }
                };

                this.send(data);
            }

            return this.startTimer();
        }, 1000);
    }

    stopTimer() {
        this.timerStopped = true;
    }
}